import React from "react";
import HomePageHeader from "../Onboarding/HomePageHeader";
import AuthFooter from "../../components/AuthFooter/AuthFooter";
import PrivacyPolicy from "../Guest/PrivacyPolicy";

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <HomePageHeader />
      <div className="flex-1 mt-16">
        <div className="max-w-4xl bg-cream mx-auto my-12 p-6 rounded-[20px]">
          <PrivacyPolicy />
        </div>
      </div>
      {/* <div className="mt-10 bg-[#111C3D] border-t border-white/20 ">
        <AuthFooter extraClasses={"footerContainer mx-auto !relative"} />
      </div> */}
    </div>
  );
}
